// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var DropdownAlignmentMap;
(function (DropdownAlignmentMap) {
    DropdownAlignmentMap["Left"] = "left";
    DropdownAlignmentMap["Right"] = "right";
})(DropdownAlignmentMap || (DropdownAlignmentMap = {}));
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var DropdownItemTypeMap;
(function (DropdownItemTypeMap) {
    DropdownItemTypeMap["Divider"] = "divider";
    DropdownItemTypeMap["Item"] = "item";
})(DropdownItemTypeMap || (DropdownItemTypeMap = {}));
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var DropdownPositionMap;
(function (DropdownPositionMap) {
    DropdownPositionMap["Down"] = "down";
    DropdownPositionMap["Left"] = "left";
    DropdownPositionMap["Right"] = "right";
    DropdownPositionMap["Up"] = "up";
})(DropdownPositionMap || (DropdownPositionMap = {}));
